// App links (requirements §8, §11): the approved Adjust links per button, and deep links into the same item
// in the app. The app reads https://www.milacelebrations.com/go/item?id=<uuid> and unwraps adj_deep_link.

const ADJUST = 'https://mila.go.link?adj_t=24av8m75&adj_adgroup=';
export const APP_STORE_URL = `${ADJUST}appstore_button`;
export const GOOGLE_PLAY_URL = `${ADJUST}playstore_button`;
export const UNIFIED_APP_URL = `${ADJUST}unified_button`;

export const itemDeepLink = (itemId: string) =>
  `${UNIFIED_APP_URL}&adj_deep_link=${encodeURIComponent(`https://www.milacelebrations.com/go/item?id=${itemId}`)}`;

export type AppHandoff = { kind: 'redirect' | 'qr'; url: string };

/** Phones follow the link (the app opens, or its store); desktops get a QR code to scan with the phone. */
export function appHandoff(userAgent: string, itemId: string | null | undefined): AppHandoff {
  const url = itemId ? itemDeepLink(itemId) : UNIFIED_APP_URL;
  return /iPhone|iPad|iPod|Android/i.test(userAgent || '') ? { kind: 'redirect', url } : { kind: 'qr', url };
}
